import React, { useEffect, useState } from 'react';
import { configData2 } from './ConfigComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfigForm from './ConfigForm';
import { useLocation, useNavigate } from 'react-router-dom';
import "./ConfigForm.css"
import SectionForm from './SectionForm';
import InputForm from './InputForm';
import { Button } from '@mui/material';
import { openPopup } from '../../stateManagement/actions/popupActions';

interface UiConfigDashboardProps {
    optionKey: string;
}

const ConfigSectionDashboard: React.FC = () => {
    const location:any = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if(!location.state){
            console.log("location.state",location.state)
            navigate("/dashboard/uiConfigDashboard");
        }
    }, []);
    const data = location.state?.data;
    const sectionName = location.state?.sectionName;
    const LOCAL_STORAGE_KEY = 'configData';
    const storedDataString = localStorage.getItem(LOCAL_STORAGE_KEY) || configData2;
    let configData: any;
    var storedData = typeof storedDataString === 'string' ? JSON.parse(storedDataString) : storedDataString;
    configData = storedData?.[data]?.subSections;
    const [activeSection, setActiveSection] = useState<string | null>(sectionName);
    const [activeInput, setActiveInput] = useState<string | null>(configData?.find((item: any) => item.sectionHeading === activeSection)?.inputFields?.[0]?.name);
    const [sectionData, setSectionData] = useState<any>(storedData?.[data]);
    const handleClick = (optionKey: string) => {
        setActiveSection(optionKey);
    };
    const handleSave = () => {
        storedData[data] = sectionData;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedData));
        openPopup('Success', `Saved Successfully`)
    };
    useEffect(() => {
        setActiveInput(sectionData?.subSections?.find((item: any) => item.sectionHeading === activeSection)?.inputFields?.[0]?.name)
        console.log("activeInput",activeInput)
    }, [activeSection,sectionData?.configurations?.length]);

    return (
        <div className="main_container">
            <div className="ui_sidebar" style={{width:"15%"}}>
                <div className='config_option_container' style={{display:"flex",justifyContent:"center",width:"100%",paddingBlock:"20px"}}>
                    {configData && configData.length > 0 && (
                        <div className="section_container" style={{gridGap:"20px"}}>
                            {configData.map((optionKey: any, index: React.Key | null | undefined) => {
                                return (
                                    <div key={index} style={{width:"100%"}} onClick={() => handleClick(optionKey.sectionHeading)} className={`uisidebar_option ${optionKey.sectionHeading === activeSection ? 'uiconfig_active_option' : ''}`}>
                                        <span>{optionKey && optionKey.sectionHeading}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
            <div className="content_container" style={{width:"45%"}}>
                {data && (
                    <SectionForm
                    sectionData={sectionData}
                    setSectionData={setSectionData}
                    activeOptionKey={data}
                    sectionName={activeSection}
                    setActiveInput={setActiveInput}
                    inputName={activeInput}
                    />
                )}
            </div>
            <div className="content_container" style={{width:"40%"}}>
                {activeInput && (
                    <InputForm
                    sectionData={sectionData}
                    setSectionData={setSectionData}
                    inputName={activeInput}
                    sectionName={activeSection}
                    activeOptionKey={data}
                    />
                )}
            </div>
            {/* <Button variant="contained" color="primary" onClick={()=>{handleSave()}}>
                    Save
            </Button> */}
        </div>
    );
};
export default ConfigSectionDashboard;
